import { render, staticRenderFns } from "./enCourseDetail.vue?vue&type=template&id=36ef2c7a&scoped=true&"
import script from "./enCourseDetail.vue?vue&type=script&lang=js&"
export * from "./enCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./enCourseDetail.vue?vue&type=style&index=0&id=36ef2c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef2c7a",
  null
  
)

export default component.exports